import React, { useMemo } from 'react';

function StatCard({ icon, label, value, color }) {
  return (
    <div className={`card p-3 sm:p-6 ${color}`}>
      <div className="text-2xl sm:text-3xl mb-2">{icon}</div>
      <p className="text-xs sm:text-sm text-on-surface-variant font-medium">{label}</p>
      <p className="text-2xl sm:text-3xl font-bold font-headline text-primary">{value}</p>
    </div>
  );
}

export default function StatsCards({ events, files }) {
  const stats = useMemo(() => {
    const today = new Date();
    const thisWeekStart = new Date(today);
    thisWeekStart.setDate(today.getDate() - today.getDay());
    const thisWeekEnd = new Date(thisWeekStart);
    thisWeekEnd.setDate(thisWeekStart.getDate() + 6);

    const completedThisWeek = events.filter((e) => {
      const eventDate = new Date(e.date);
      return e.status === 'completed' && eventDate >= thisWeekStart && eventDate <= thisWeekEnd;
    }).length;

    const activeTasks = events.filter((e) => e.type === 'task' && e.status !== 'completed').length;
    const upcomingMilestones = events.filter(
      (e) => e.type === 'milestone' && e.status === 'active'
    ).length;
    const recentFiles = files.length;

    return {
      activeTasks,
      completedThisWeek,
      upcomingMilestones,
      recentFiles,
    };
  }, [events, files]);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      <StatCard
        icon="✓"
        label="Completed This Week"
        value={stats.completedThisWeek}
        color="bg-surface-container-low"
      />
      <StatCard
        icon="📋"
        label="Active Tasks"
        value={stats.activeTasks}
        color="bg-surface-container-low"
      />
      <StatCard
        icon="🎯"
        label="Upcoming Milestones"
        value={stats.upcomingMilestones}
        color="bg-surface-container-low"
      />
      <StatCard
        icon="📁"
        label="Files Shared"
        value={stats.recentFiles}
        color="bg-surface-container-low"
      />
    </div>
  );
}
